module.exports = __webpack_public_path__ + "img/Statut_Completed.b11da991.svg";